import { SecondaryButton } from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { useAuthenticationLocaleText } from '../../../../text-localisation'

export type SignInWithCodeButtonProps = {
  onClick: (e: React.FormEvent) => void
}

export const SignInWithACodeButton: FC<SignInWithCodeButtonProps> = props => {
  const localiseText = useAuthenticationLocaleText()

  return (
    <SecondaryButton width="100%" mb={6} onClick={props.onClick} type="button">
      {localiseText('sign_in_with_code.button')}
    </SecondaryButton>
  )
}
